module.exports = __webpack_public_path__ + "static/media/C029.8038a679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C029.jpg
// module id = 312
// module chunks = 0